module.exports = __webpack_public_path__ + "img/header.70558bf.jpg";